import { render } from "./MoviePage.vue?vue&type=template&id=1f7d83d8&scoped=true"
import script from "./MoviePage.vue?vue&type=script&lang=js"
export * from "./MoviePage.vue?vue&type=script&lang=js"

import "./MoviePage.vue?vue&type=style&index=0&id=1f7d83d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7d83d8"]])

export default __exports__